import { render, staticRenderFns } from "./CorrelationSearch.vue?vue&type=template&id=085b2dd0&scoped=true"
import script from "./CorrelationSearch.vue?vue&type=script&lang=js"
export * from "./CorrelationSearch.vue?vue&type=script&lang=js"
import style0 from "./CorrelationSearch.vue?vue&type=style&index=0&id=085b2dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085b2dd0",
  null
  
)

export default component.exports